import React from 'react';
import { Close, Container, Content } from './edit-avatar.styled';

function EditAvatar({ closeModal, profile, handleProfile, loading }) {
  return (
    <Container>
      <Close onClick={closeModal}>X</Close>
      <Content>
        {profile.avatarUrl
          ? 'Nós utilizamos a api do Github, a foto é a mesma do Github. para alterar a foto, você precisa alterar a foto do Github.'
          : 'Nós utilizamos a api do Github, preencha o endereço do seu Github no perfil Codivas para buscarmos a sua foto.'
            // <Typography>Preenche abaixo</Typography>
            // <FormContainer onSubmit={handleProfile}>
            //   <TextField
            //     placeholder="username"
            //     label="Github"
            //     name="githubUsername"
            //     defaultValue={profile.githubUsername}
            //   />
            //   <SubmitInput
            //     type="submit"
            //     name=""
            //     loading={loading}
            //     value={loading ? loading : "Salvar"}
            //   />
            // </FormContainer>
        }
      </Content>
    </Container>
  );
}

export default EditAvatar;
